import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { deviceIdSchema } from "./deviceSchema";

export const calibrationIdPrefix = "cal_";
export type CalibrationId = ID<typeof calibrationIdPrefix>;
export const generateCalibrationId = makeIdGenerator(calibrationIdPrefix);
export const calibrationIdSchema = getIdSchema(
  calibrationIdPrefix,
  "CalibrationId",
);

export const calibrationSchema = z
  .object({
    id: calibrationIdSchema,
    time: z.coerce.date(),
    deviceId: deviceIdSchema,
    rawWeights: z.array(z.number()),
    calibratedWeights: z.array(z.number()),
  })
  .meta({ id: "Calibration" });

export type Calibration = z.infer<typeof calibrationSchema>;
